export enum ScheduleType {
    WhenFound = "when_found",
    TimeWindow = "time_window",
}

export type RolloutFormValues = {
    notes?: string;
    scheduleType: ScheduleType;
    windowStart?: Date | null;
    windowEnd?: Date | null;
    [deviceKey: `d${number}`]: boolean;
};

const formKeyDevicePrefix = "d";
export const treeItemIndentPx = 24;

export type DeviceFormKey = `d${number}`;

const deviceKeyRegex = /^d\d+$/;

const isDeviceKey = (key: string): key is DeviceFormKey => deviceKeyRegex.test(key);
export const toDeviceKey = (id: number): DeviceFormKey => `${formKeyDevicePrefix}${id}`;

export const countSelectedDevices = (values: Record<string, unknown> | undefined): number => {
    if (!values) {
        return 0;
    }
    return Object.entries(values).filter(([key, val]) => isDeviceKey(key) && val === true).length;
};

export const getSelectedDeviceIds = (values: Record<string, unknown> | undefined): number[] => {
    if (!values) {
        return [];
    }
    return Object.entries(values)
        .filter(([key, val]) => isDeviceKey(key) && val === true)
        .map(([key]) => Number(key.slice(formKeyDevicePrefix.length)));
};
